
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/color-palette-from-image",
      function () {
        return require("private-next-pages/color-palette-from-image/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/color-palette-from-image"])
      });
    }
  